import type { SelectedEntity } from '../../api/types.ts';

export type ConfiguredSyncMode = Pick<SelectedEntity, 'sync_mode' | 'incremental_behavior'>;

/** Saved configuration, not the execution mode of the current ingestion run. */
export function configuredSyncModes(entities: readonly SelectedEntity[]): ReadonlyMap<string, ConfiguredSyncMode> {
  return new Map(entities.map(entity => [entity.entity_name, {
    sync_mode: entity.sync_mode,
    incremental_behavior: entity.incremental_behavior,
  }]));
}

export function syncModeLabel(configuration: ConfiguredSyncMode | undefined): string {
  switch (configuration?.sync_mode) {
    case 'incremental': return configuration.incremental_behavior === 'append_only'
      ? 'Incremental append-only' : 'Incremental reconcile';
    case 'full': return 'Full snapshot';
    case 'cdc': return 'CDC';
    default: return 'Not available';
  }
}